import React, {useMemo, useEffect, useState} from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { usePharmaReceivingUIContext } from "./PharmaReceivingUIContext";
import { PharmaReceivingTable } from "./PharmaReceivingTable";
import { PharmaReceivingFilters } from "./PharmaReceivingFilters";
import { errorMsg } from "../../../Global/helpers";
import * as pharmaCrud from '../../_redux/pharma/pharmaCrud'
import * as actions from "../../_redux/pharma-deliveries/pharmaDeliveriesActions";
import { useDispatch } from "react-redux";
import { informarMailRetiroFarmacia } from "../../mailRetiroFarmacia";


const logistic_states = [
  {value:1, label:'Pendiente'},
  {value:2, label:'En Armado'},
  {value:3, label:'En Distribución'},
  {value:4, label:'Entregado'},
  {value:5, label:'Cancelado'},
  {value:6, label:'Sin Despacho'}
]

export function PharmaReceivingCard() {
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const {orderForEdit, ordersQueryParams} = usePharmaReceivingUIContext();


    const dispatch = useDispatch();

    const orderConfirmation = async ()=>{
      try{
        const resp = await pharmaCrud.setOrderReceived(orderForEdit)
        dispatch(actions.fetchOrders(ordersQueryParams));
        setShowConfirmationDialog(false)
        // Aviso al cliente de que ya puede retirar el pedido (solo unidad de negocio Mi Test)
        await informarMailRetiroFarmacia(orderForEdit.id, resp?.data?.mail_retiro_farmacia)
      }
      catch(err){
          console.log(err)
          errorMsg("Error al guardar pedido")        
      }
    }

//     useEffect(()=>{
// console.log(orderForEdit)
//     }, [orderForEdit])


    return (
      <>
        <Modal size="lg" show={showConfirmationDialog}  backdrop='static' >
            <Modal.Header closeButton>
              <Modal.Title>Confirmación de recepción de pedido</Modal.Title>
            </Modal.Header>

            <Modal.Body className="overlay overlay-block cursor-default">
              <p>Confirma la recepción del pedido <b>{orderForEdit.id}</b> ? </p>
              <br/>
              <table className="table">
                <thead>
                  <tr>
                    <td style={{textAlign:'center'}}>Producto</td>
                    <td style={{textAlign:'center'}}>SKU</td>
                    <td style={{textAlign:'center'}}>Cantidad</td>
                  </tr>
                </thead>
                <tbody>
                  { orderForEdit?.lines?.map( detalle=>(
                    <tr key={detalle.id}>
                      <td style={{textAlign:'left'}}>{detalle.product}</td>
                      <td style={{textAlign:'center'}}>{detalle.sku}</td>
                      <td style={{textAlign:'center'}}>{detalle.qty}</td>
                    </tr>
                  ))}

                </tbody>
              </table>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={()=>setShowConfirmationDialog(false)}>Cancelar</Button>
              <Button variant="primary" onClick={()=>orderConfirmation()}>Confirmar Recepción</Button>
            </Modal.Footer>
        </Modal>

        <Card>

          <CardHeader title="Recepciones Farmacia">

            {/* <CardHeaderToolbar>
              <PharmaReceivingViews />
            </CardHeaderToolbar> */}

          </CardHeader>
          
          <CardBody>

          <PharmaReceivingFilters />

          <PharmaReceivingTable setShowConfirmationDialog={setShowConfirmationDialog} />

          </CardBody>
        
        </Card>
      </>
    );
}
